// extracted by mini-css-extract-plugin
module.exports = {"pinPadContainer":"pin-pad_pinPadContainer__1fkDd","removeButton":"pin-pad_removeButton__1RRZ9","removeIcon":"pin-pad_removeIcon__2Qp2h"};